const afterSalahData = {
  brand: "أذكار بعد الصلاة",
  title: "من قالها بعد كل صلاة غفرت خطاياه وإن كانت مثل زبد البحر",
  text:
    "أستغفر الله - ثلاث مرات - اللهم أنت السلام ومنك السلام تباركت ياذا الجلال والإكرام , لا إله إلا الله وحده لا شريك له , له الملك , وله الحمد , وهو علي كل شئ قدير , لا حول ولا قوة إلا بالله , لا إله إلا الله , ولا نعبد إلا إياه , لع النعمة وله الفضل , وله الثناء الحسن, لاه إله إلا الله, مخلصين له الدين ولو كره الكافرون, اللهم لا مانع لما أعطيت, ولا معطي لما منعت, ولا ينفع ذا الجد منك الجدز",
  awradList: [
    {
      id: 1,
      title: "سبحان الله - 33 مرة",
    },
    {
      id: 2,
      title: "الحمد لله - 33 مرة",
    },
    {
      id: 3,
      title: "الله أكبر - 33 مرة",
    },
  ],
  text2:
    "ثم يتم المائة بقوله لا إله إلا الله وحده لا شريك له , له الملك , وله الحمد وهو علي كل شئ قدير",
};

export default afterSalahData;
